module.exports = __webpack_public_path__ + "images/premium2-a85006e475e115a5a50c772852ded948.jpg";